$(document).ready(function () {

    // notification_profile_filter e so um filtro de tela: ajuda o admin a achar
    // usuario na lista de selecao individual, mostrando so o bloco do perfil
    // escolhido. Nunca desmarca quem ja foi selecionado -- e o que permite
    // misturar usuario, professor e prestador na mesma notificacao.
    function notificationUserBlockIds() {
        return $('.users-notification').map(function () { return this.id; }).get();
    }

    function applyNotificationProfileFilter() {
        let selected = $('#notification_profile_filter').val();
        notificationUserBlockIds().forEach(function (id) {
            let isTarget = !selected || id === 'users-notification-' + selected;
            hideElement(id, !isTarget);
        });
    }

    $(document).on('change', '#notification_profile_filter', function () {
        if ($('#notification_send_all').val() === 'true') {
            return;
        }
        applyNotificationProfileFilter();
    });

    $(document).on('change', '#notification_send_all', function () {
        if (this.value == 'true') {
            notificationUserBlockIds().forEach(function (id) { hideElement(id, true); });
        } else {
            applyNotificationProfileFilter();
        }
    });

    // Tela de destino: mostra e habilita so o select de registro do tipo
    // escolhido. Os tres selects tem o mesmo name (notification[destination_id]);
    // o escondido fica disabled para nao ser submetido e sobrescrever o valor.
    // "Nenhuma" e "Ao vivo" nao tem registro, entao nenhum select aparece.
    let DESTINATION_RECORD_TYPES = ['event', 'clinic', 'benefit'];

    $(document).on('change', '#notification_destination_type', function () {
        let selected = this.value;
        DESTINATION_RECORD_TYPES.forEach(function (tipo) {
            let isTarget = tipo === selected;
            let selectId = 'notification_destination_' + tipo + '_id';
            if (!isTarget) {
                $('#' + selectId).val('').trigger('change');
            }
            // disable antes do hide: hideElement recria o select2, que assim ja
            // nasce com o estado disabled correto.
            disableElement(selectId, !isTarget);
            hideElement('destination-' + tipo, !isTarget);
            $('#' + selectId).trigger('change.select2');
        });
    });

    let MANAGE_READ_NOTIFICATION = 'read-notification';
    let URL_MANAGE_LIKED_MESSAGE = '/manage_read_notification';

    $(document).on('click', '.' + MANAGE_READ_NOTIFICATION, function () {
        var notification_id = this.id.split("-")[2];
        $.getJSON(
            URL_MANAGE_LIKED_MESSAGE,
            {
                id: notification_id
            },
            function (data) {
                if (data.result == true) {
                    if (data.read == true) {
                        $('.read-notification-' + notification_id).remove();
                    }
                    $(".notifications-icon-number").text(data.quantity);
                } else {
                    alert(data.message);
                }
            });
    });

});
